export function chainEventHandlers<T extends (event: any) => unknown>(...fns: T[]) {
  return (event: Parameters<T>[0]) => {
    return fns.some((fn) => {
      fn?.(event);
      return event?.defaultPrevented;
    });
  };
}
